export default "__VITE_ASSET__B8WCB22z__"